import history from '../../util/history'

const toAuditLogTabView = (basePath, reservationId) => {
  history.replace(`${basePath}/${reservationId}/log`)

  return true
}

export default toAuditLogTabView
